<template>
  <div class="title-type">
    <title-cell
      v-for="(item, index) in cptTitleData"
      :key="index"
      :item="item"
      :index="index"
    ></title-cell>
  </div>
</template>
<script>
import TitleCell from './title-cell'
import { titleData } from './config'
export default {
  name: 'title-type',
  props:['quesType'],
  components: {
    TitleCell,
  },
  data() {
    return {
      cptTitleData:[],
    }
  },
  watch:{
    quesType(val){
      if(val){
        this.cptTitleData = val;
      }
    }
  },
  created() {
    if(this.quesType){
      this.cptTitleData = this.quesType;
    }
  }
}
</script>
<style lang="scss" scoped>
.title-type {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/tariff/title-type/index.vue